var _style, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMyRewards = function SvgMyRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MyRewards_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".MyRewards_svg__st1{fill:#262a30}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyRewards_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MyRewards_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MyRewards_svg__st1",
    d: "M46.3 30.1H17.7c-1.1 0-2-.9-2-2v-1.5c0-1.1.9-2 2-2h28.7c1.1 0 2 .9 2 2v1.5c-.1 1.1-1 2-2.1 2zm-28.6-3.9c-.3 0-.5.2-.5.5v1.5c0 .3.2.5.5.5h28.7c.3 0 .5-.2.5-.5v-1.5c0-.3-.2-.5-.5-.5H17.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MyRewards_svg__st1",
    d: "M43.7 48.4h-23c-1 0-1.8-.8-1.8-1.8V29.3c0-.4.3-.8.8-.8s.8.3.8.8v17.3c0 .2.2.3.3.3h23.1c.2 0 .3-.2.3-.3V29.3c0-.4.3-.8.8-.8s.8.3.8.8v17.3c-.2 1-1.1 1.8-2.1 1.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MyRewards_svg__st1",
    d: "M32.2 48.4c-.4 0-.8-.3-.8-.8V25.4c0-.4.3-.8.8-.8s.8.3.8.8v22.3c-.1.4-.4.7-.8.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MyRewards_svg__st1",
    d: "M36.7 26.2h-4.6c-.4 0-.8-.3-.8-.8v-4.6c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3-2.2 5.4-5.2 5.4zm-3.8-1.5h3.8c2.1 0 3.8-1.7 3.8-3.8s-1.7-3.8-3.8-3.8-3.8 1.7-3.8 3.8v3.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MyRewards_svg__st1",
    d: "M32.2 26.2h-3.4c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2S33 19.7 33 22v3.4c-.1.4-.4.8-.8.8zm-3.5-6.9c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7h2.7V22c0-1.5-1.2-2.7-2.7-2.7z"
  })));
};
export default SvgMyRewards;